/* global imagepaths connect React Component */
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import sidemenu from "./sidemenu";
const Sidebar = (props) => {
    const [isSideMenu, setSideMenu] = useState("");
    const location = useLocation();
    const toggleSidebar = (value) => {
        console.log(value);
        setSideMenu(value);
    };

    let pathname = location.pathname;

    const filterMenu = (menu)=>{
        let hasRoles = menu.roles||[];
        let roleAuthenticated = hasRoles.length?hasRoles.includes(props.store?.user?.user_role):true;
        let hasRules = menu.rule?menu.rule(props?.store?.user,props):true;
        return roleAuthenticated && hasRules;
    };
    return (
        <div className="sidebar" id="sidebar">
            <div className="sidebar-inner slimscroll">
                <div id="sidebar-menu" className="sidebar-menu">
                    <ul>
                        <li className="menu-title">
                            <span>Menu</span>
                        </li>
                        {/* DASHBOARD */}
                        {
                            sidemenu
                            .filter(filterMenu)
                            .map(menu => (
                                <li key={menu.name} className={Object.className({ "submenu": menu.children.length, "active": pathname.includes(menu.link) })}>
                                    {menu.children.length ? <a
                                        href="#"
                                        className={isSideMenu == menu.name ? "subdrop" : ""}
                                        onClick={() =>
                                            toggleSidebar(isSideMenu == menu.name ? "" : menu.name)
                                        }
                                    >
                                        <i className={menu.icon} /> <span> {menu.label}</span>{" "}
                                        <span className="menu-arrow" />
                                    </a> :
                                        <Link to={menu.link} className={
                                            pathname.includes(menu.link) ? "active" : ""
                                        }>
                                            <i className={menu.icon} /> <span>{menu.label}</span>
                                        </Link>}

                                    {menu.children.length && isSideMenu == menu.name ? (
                                        <ul>
                                            {
                                                menu.children.map(submenu => (
                                                    <li key={submenu.name}>
                                                        <Link
                                                            className={
                                                                pathname==submenu.link ? "active" : ""
                                                            }
                                                            to={submenu.link}
                                                        >
                                                            {submenu.label}
                                                        </Link>
                                                    </li>
                                                ))
                                            }

                                        </ul>
                                    ) : (
                                        ""
                                    )}
                                </li>

                            ))
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default connect(Sidebar);
